import { motion } from 'framer-motion';

const risks = [
  {
    icon: 'ri-close-circle-line',
    title: 'Rechazo del trámite',
    desc: 'Documentación incompleta o errores formales pueden generar el rechazo de la solicitud ante el Registro Civil o tribunal.',
  },
  {
    icon: 'ri-time-line',
    title: 'Retrasos en acceso a bienes y dinero',
    desc: 'Un proceso mal iniciado puede extenderse meses adicionales, bloqueando el acceso a propiedades, cuentas y otros activos.',
  },
  {
    icon: 'ri-home-2-line',
    title: 'Problemas al vender propiedades o transferir bienes',
    desc: 'Sin la posesión efectiva correctamente inscrita, no es posible vender, transferir ni gestionar los bienes del causante.',
  },
  {
    icon: 'ri-money-dollar-circle-line',
    title: 'Costos adicionales por correcciones',
    desc: 'Enmendar errores del proceso original implica tiempo, honorarios extra y gestiones adicionales que se pueden evitar.',
  },
];

const PosesionRisk = () => {
  const scrollToForm = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const el = document.getElementById('posesion-efectiva-form');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section className="py-24 bg-black">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-14"
        >
          <span className="inline-flex items-center gap-2 bg-red-500/15 text-red-400 text-xs font-black uppercase tracking-widest px-4 py-1.5 rounded-full mb-5">
            <i className="ri-alert-line text-sm"></i>
            Riesgos reales
          </span>
          <h2 className="text-4xl lg:text-5xl font-extrabold text-white leading-tight mb-4">
            ¿Por qué hacerlo correctamente
            <br />
            <span className="text-primary-yellow">desde el inicio?</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto leading-relaxed">
            Un error en el proceso puede costar mucho más que el trámite mismo. Estos son los problemas más frecuentes cuando no se gestiona con respaldo profesional.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-5 mb-12">
          {risks.map((item, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.1, duration: 0.5 }}
              className="flex items-start gap-5 bg-white/4 border border-red-500/20 rounded-2xl p-6"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-red-500/15 rounded-xl flex-shrink-0 mt-0.5">
                <i className={`${item.icon} text-red-400 text-xl`}></i>
              </div>
              <div>
                <h3 className="text-white font-bold text-base mb-1.5">{item.title}</h3>
                <p className="text-gray-400 text-sm leading-relaxed">{item.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="text-center"
        >
          <p className="text-gray-400 text-sm mb-6 max-w-lg mx-auto">
            Evita estos problemas contando con un equipo que conoce el proceso y lo gestiona correctamente desde el primer paso.
          </p>
          <a
            href="#posesion-efectiva-form"
            onClick={scrollToForm}
            className="inline-flex items-center gap-2 bg-primary-yellow text-black px-8 py-4 rounded-full font-bold text-base hover:bg-yellow-400 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-shield-check-line text-lg"></i>
            Iniciar trámite con asesoría
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default PosesionRisk;
